import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import FormHelperText from '@mui/material/FormHelperText';
import MuiRadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import Typography from '@mui/material/Typography';
import useUniqueId from '../hooks/useUniqueId';

const labelSx = {
    position: 'relative',
    transform: 'none',
    mb: 0.5,
    fontSize: '0.875rem',
    fontWeight: 500,
    color: 'text.primary',
    '&.Mui-focused': {
        color: 'text.primary',
    },
};

const RadioGroup = ({
    label,
    labelId: labelIdProp,
    labelDataAutomationId,
    name,
    dataAutomationId,
    value,
    onChange,
    options,
    error = false,
    helperText,
    required = false,
    disabled = false,
    fullWidth = true,
    row = false,
    size = 'small',
    sx,
}) => {
    const groupId = useUniqueId('radiogroup');
    const labelId = labelIdProp || `${groupId}-label`;
    const helperId = `${groupId}-helper`;

    return (
        <FormControl fullWidth={fullWidth} error={error} disabled={disabled} sx={sx}>
            {label && (
                <FormLabel id={labelId} required={required} sx={labelSx}
                    {...(labelDataAutomationId ? { 'data-automation-id': labelDataAutomationId } : {})}>
                    {label}
                </FormLabel>
            )}
            <MuiRadioGroup
                name={name}
                value={value}
                onChange={onChange}
                row={row}
                aria-labelledby={label ? labelId : undefined}
                aria-describedby={helperText ? helperId : undefined}
                aria-required={required || undefined}
                aria-invalid={error || undefined}
                {...(dataAutomationId ? { 'data-automation-id': dataAutomationId } : {})}
            >
                {options.map((option) => (
                    <FormControlLabel
                        key={option.value}
                        value={option.value}
                        disabled={option.disabled}
                        control={
                            <Radio
                                size={size}
                                inputProps={{
                                    ...(option.id ? { id: option.id } : {}),
                                    ...(option.dataAutomationId ? { 'data-automation-id': option.dataAutomationId } : {}),
                                }}
                            />
                        }
                        label={
                            option.hint ? (
                                <>
                                    {option.label}
                                    <Typography variant="caption" sx={{ color: 'error.main', ml: 0.5 }}>
                                        {option.hint}
                                    </Typography>
                                </>
                            ) : option.label
                        }
                    />
                ))}
            </MuiRadioGroup>
            <FormHelperText id={helperId} sx={{ my: 0}}>{helperText || ' '}</FormHelperText>
        </FormControl>
    );
};

export default RadioGroup;
